import React from 'react';
import { makeStyles } from '@material-ui/core';
import { scissorStates } from '../../Config/scissorStates'
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

export const TableStateComponent = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    let tableStatus = "";
    if (props.tableStatus) {
        tableStatus = props.tableStatus;
    }

    console.log(props.size)

    let status = "";
    switch (tableStatus.name) {
        case scissorStates.PRODUCTION:
            status = scissorStates.PRODUCTION.toUpperCase();
            break;
        case scissorStates.SCRAP:
            status = scissorStates.SCRAP.toUpperCase();
            break;
        case scissorStates.UNPLANNEDSTOP:
            status = scissorStates.UNPLANNEDSTOP.toUpperCase();

            break;
        case scissorStates.PLANNEDSTOP:
            status = scissorStates.PLANNEDSTOP.toUpperCase();
            break;
        default:
    }

    return (
        <div className={classes.container} style={{ borderRadius: "5px", border: "1px solid #DEDEDE", borderBottom: "1px solid #DEDEDE" }}>
            {props.size !== "S" &&
                <div className={classes.arrow}>
                    <div className={classes.lineNumber}>{props.machineNumber}</div>
                </div>
            }
            <div className={classes.status} style={{ backgroundColor: tableStatus.backgroundColorInHex, color: tableStatus.foregroundColorInHex, fontSize: props.size === "M" ? "20px" : props.size === "S" ? "10px" : "0.8rem", textWrap: "nowrap" }}>
                {t(status)}
            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        justifyContent: "center",
    },
    status: {
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        padding: "10px",
    },
    lineNumber: {
        float: "left",
        fontSize: "30px",
        fontFamily: "Lato, sans-serif",
        boxSizing: "border-box",
    },
    arrow: {
        width: "40%",
        float: "left",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    arrowIcon: {
        height: "20px",
    }
}));

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState
    }
}

export default connect(mapStateToProps)(TableStateComponent)